import { ArrowBackRounded } from "@mui/icons-material";
import { Collapse, IconButton } from "@mui/material";
import React, { useState } from "react";
import ImportInstruction from "./ImportInstruction";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [showInstr, setShowInstr] = useState(false);

  const handleInstruction = () => {
    setShowInstr(!showInstr);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="rounded-[15px] p-[5px] mt-[10px]">
      <div className="flex items-center gap-3">
        <IconButton onClick={handleBack} size="large">
          <ArrowBackRounded />
        </IconButton>
        <div className="flex flex-col">
          <span className="text-[20px] font-medium text-gray-500 uppercase">
            Import Products
          </span>
          <span className="text-[14px] text-gray-500">
            Create a spreadsheet file. Your data will be checked for common
            errors before it's uploaded.{" "}
            <span
              onClick={handleInstruction}
              className="underline font-medium hover:cursor-pointer hover:text-primary"
            >
              Need help?
            </span>
          </span>
        </div>
      </div>
      <Collapse in={showInstr}>
        <ImportInstruction />
      </Collapse>
    </div>
  );
};

export default Header;
